module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/model_white-b13dce50f798c32a7869a7130b61afc5.png";